export const menuManagementTranslations = {
    en: {
        // Page Title
        pageTitleMaster: "Menu Master",

        // Buttons & Actions
        addMenu: "Add Menu",
        addNewMenu: "Add New Menu",
        updateMenu: "Update Menu",
        deleteMenu: "Delete Menu",
        edit: "Edit",
        delete: "Delete",
        permission: "Permission",

        // Table Headers & Labels
        name: "Name",
        url: "URL",
        icon: "Icon",
        searchPlaceholder: "Search...",
        menuMaster: "Menu Master",

        // Navigation Status
        navigationOn: "Navigation: On",
        navigationOff: "Navigation: Off",

        // Messages
        noMenusFound: "No menus found",
    },
    mr: {
        // Page Title
        pageTitleMaster: "मेनू मास्टर",

        // Buttons & Actions
        addMenu: "मेनू जोडा",
        addNewMenu: "नवीन मेनू जोडा",
        updateMenu: "मेनू अद्यतनित करा",
        deleteMenu: "मेनू हटवा",
        edit: "संपादित करा",
        delete: "हटवा",
        permission: "अनुमती",

        // Table Headers & Labels
        name: "नाव",
        url: "URL",
        icon: "आयकन",
        searchPlaceholder: "शोधा...",
        menuMaster: "मेनू मास्टर",

        // Navigation Status
        navigationOn: "नेव्हिगेशन: चालू",
        navigationOff: "नेव्हिगेशन: बंद",

        // Messages
        noMenusFound: "कोणतेही मेनू सापडले नाही",
    }
};
